'use client';
/** @jsxImportSource @emotion/react */

import type { SelectProps as MuiSelectProps } from '@mui/material/Select';

import MuiSelect from '@mui/material/Select';

import { CoreIcon } from '../core-icon/CoreIcon';

type ExcludedMuiProps = 'defaultOpen' | 'displayEmpty' | 'IconComponent';
type SelectProps<T = unknown> = Omit<MuiSelectProps<T>, ExcludedMuiProps>;

function ChevronDown(props: Record<string, unknown>) {
  return <CoreIcon {...props} name="chevrondown" />;
}

export type { SelectProps };
export const Select = <T = unknown,>(props: SelectProps<T>) => {
  return <MuiSelect IconComponent={ChevronDown} {...props} />;
};
